import { css } from "styled-components";

const hydrateStyledCss = (styledCss: any, props: any) => {
    const segments: string[] = [];

    if (typeof styledCss === "object") {
        styledCss.forEach((segment: any) => {
            if (typeof segment === "function") {
                segments.push(hydrateStyledCss(css({}, segment(props)), props));
            } else {
                segments.push(segment);
            }
        });
    }

    return segments.join("");
};

export default hydrateStyledCss;
